import moment, { type Moment } from 'moment';

import { DateUtil } from '@src/packages/utils/dates';

/** Chile-local "today" as YYYY-MM-DD for planning date validation. */
export const todayIsoInChile = (): string =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Santiago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());

/** End of the month that contains `startDate` (inclusive), as YYYY-MM-DD. */
export const resolvePlanEndDateIso = (startDate: Moment | null): string | null => {
  if (!startDate || !startDate.isValid()) return null;
  return startDate.clone().endOf('month').format('YYYY-MM-DD');
};

export const resolvePlanStartDateIso = (startDate: Moment | null): string | null => {
  if (!startDate || !startDate.isValid()) return null;
  return startDate.format('YYYY-MM-DD');
};

export const isPlanStartDateAllowed = (startDate: Moment | null): boolean => {
  const startIso = resolvePlanStartDateIso(startDate);
  if (!startIso) return false;
  return startIso >= todayIsoInChile();
};

export const formatPlanDateDisplay = (isoDate: string | null | undefined): string => {
  if (!isoDate) return '—';
  const ms = DateUtil.getTimestampMs(`${isoDate}T12:00:00`) ?? Date.parse(`${isoDate}T12:00:00`);
  if (!Number.isFinite(ms)) return isoDate;
  return DateUtil.toDateString(ms, 'DD/MM/YY');
};

/** Ant Design DatePicker: block every day before Chile-local today. */
export const disablePastPlanDates = (current: Moment | null): boolean => {
  if (!current) return false;
  const today = moment(todayIsoInChile(), 'YYYY-MM-DD').startOf('day');
  return current.clone().startOf('day').isBefore(today);
};
